const routes = [
    {
        path: "/staff",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "staff_index"
        }
    },
    {
        path: "/staff/:id",
        component: () => import("../pages/Information/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "staff_show"
        }
    },
    {
        path: "/staff/documents/:id",
        component: () => import("../pages/Documents"),
        meta: {
            isAuthenticated: true,
            permission: "staff_show"
        }
    },
];

export default routes;
